<template>
<div>
	<div v-if="data" class="row">
		<div class="col-md-12">
			<div class="panel">
				<div class="panel-heading">
					<h3 class="m-t-0 font-medium">
						{{ $platform.setting.number_symbol }}{{ data.id }} {{ data.name }}
					</h3>
				</div>
				<div class="panel-body">
					<div class="row">
						<div class="col-md-4">
							<div class="form-group" :class="{ 'has-error' : errors.has('Name') }">
								<label class="control-label">Nombre *</label>
								<input v-validate="'required'" v-model="data.name" name="Name" type="text" class="form-control">
								<small v-show="errors.has('Name')" class="form-text text-danger">
									{{ errors.first('Name') }}
								</small>
							</div>
						</div>
						<div v-if="statuses" class="col-md-4">
							<div v-if="statuses.length" class="form-group">
								<label>Estado</label>
								<select v-model="data.provider_status_id" class="form-control">
									<option v-for="status in statuses" :value="status.id">
										<span v-if="status.lang">
											{{ status.lang.name }}
										</span>
										<span v-else>
											{{ status.name }}
										</span>
									</option>
								</select>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group">
								<label>Número de identificación (NIF/CIF)</label>
								<input v-model="data.identification_number" type="text" class="form-control">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label>Persona de contacto</label>
								<input v-model="data.contact_person" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>E-mail</label>
								<input v-model="data.email" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>E-mail 2</label>
								<input v-model="data.email_2" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Fax</label>
								<input v-model="data.fax" type="text" class="form-control">
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label>Teléfono</label>
								<input v-model="data.phone" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Teléfono 2</label>
								<input v-model="data.phone_2" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Móvil</label>
								<input v-model="data.mobile" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Móvil 2</label>
								<input v-model="data.mobile_2" type="text" class="form-control">
							</div>
						</div>
					</div>
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button
							class="ladda-button btn btn-success"
							ref="btnUpdate"
							data-style="expand-right"
							data-size="s"
							@click="validate()"> 
								<span class="ladda-label">Guardar</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="col-md-12">
			<places
				@reload="reloadData"
				:user="user"
				:isAuth="isAuth"
				:resource="resource"
				:places="data.places">
			</places>
		</div>
	</div>
</div>
</template>

<script>
	import Places from './../../../projects/places/layout/Places.vue'
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'places': Places,
		},
		data () {
			return {
				statuses: null,

				resource: null,

				media: null,
				data: null,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getStatus()
				this.getData()
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					return result
				})
			},
			getStatus() {
				this.$http.get('admin/management/providers/statuses')
				.then(response => {
					this.statuses = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getData() {
				this.$http.get('admin/management/providers/' + this.$route.params.id + '/edit')
				.then(response => {
					this.data = response.body
					this.resource = 'admin/management/providers/' + this.data.id
				}).catch(function(response) {
					console.log(response)
				})
			},
			reloadData() {
				this.getData()
			},
			update() {
				var loading = Ladda.create(this.$refs.btnUpdate);
				loading.start()
				this.$http.put('admin/management/providers/' + this.data.id, this.data)
				.then(response => {
					loading.stop()
					this.reloadData()
					swal({ 
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					loading.stop()
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/providers/views/Edit.vue